import { styled } from '@material-ui/core/styles';

export const Wrapper = styled('div')({
  textAlign: 'center',
  '& img': {
    margin: '1rem',
  },
});
